export const NOTIFICATIONS_ROUTE = 'powiadomienia';
export const NOTIFICATIONS_PANEL_ROUTE = NOTIFICATIONS_ROUTE + '/lista';
